export default __webpack_public_path__ + "static/media/ponente-Miguel.53a2d417.png";